import Svg, { Defs, Circle, Path } from 'react-native-svg';

export default function WscInMeLogo(props) {
	return <Svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 181.89 181.89"
				{...props}
			>
				<Circle cx={90.94} cy={90.94} r={90.94} fill="#e6e6e6" />
				<Path d="M13.31 61.22A82.83 82.83 0 00125.93 166z" fill="#2c94d1" />
				<Path
					d="M55.16 16.21a83.09 83.09 0 00-41.85 45L125.93 166a83.1 83.1 0 0041.86-45z"
					fill="#273a5e"
				/>
				<Path
					d="M90.55 8.29a82.49 82.49 0 00-35.39 7.92l112.63 104.73A82.84 82.84 0 0090.55 8.29z"
					fill="#d10031"
				/>
				<Circle cx={90.55} cy={91.08} r={81.17} fill="none" />
				<Path
					d="M153.89 50.65v-.46h-31.27v10.15l-12-11.94-.51 1.79H91.48l-6.08-6.07-1.72 6.07h-4.62v11.17L61.82 44.12l-5.14 18.12-18.12-18.12v46L77 128.61l-.09.33-23.81-23.82-.37 1.14L39.66 93.2l-7.75 8.27 7.93 7.93-9.09 27.68L60 166.29A81.22 81.22 0 00166.67 62.84L154 50.19z"
					opacity={0.55}
				/>
				<Path
					d="M60 166.29a81.42 81.42 0 0064.69-1.53L38.56 84.7v5.46L77 128.61l-.09.33-23.81-23.82-.37 1.14L39.66 93.2l-7.76 8.27 7.94 7.93-9.09 27.68z"
					fill="#14435e"
				/>
				<Path
					d="M85.36 44.29l-1.68 5.9h-4.62v11.17L61.82 44.12l-5.14 18.12-18.12-18.12V84.7l86.09 80.06a81.51 81.51 0 0041.86-45z"
					fill="#12192a"
				/>
				<Path
					d="M166.51 119.75a81.49 81.49 0 00.16-56.91L154 50.19l-.13.46v-.46h-31.25v10.15l-12-11.94-.51 1.79h-18.4z"
					fill="#5e0016"
				/>
				<Path
					d="M74 44.12h11.7l-12.29 46H61.82L56 62.89l-5.92 27.27H38.56l-11.87-46h11.87l5.93 26.16 6.15-26.16h11.18l5.93 26.74z"
					fill="#ffffff"
				/>
				<Path
					d="M92.6 76.21a3.4 3.4 0 00-.07.76c0 2.28 2.48 4.21 5.45 4.21 2.69 0 4.76-1.58 4.76-3.65s-1.24-3.11-6.62-5c-10.08-3.59-14-7.8-14-14.84 0-8.63 6.35-14.43 15.94-14.43 6.21 0 11.32 2.63 14 7.11a18 18 0 012.42 7.39h-11.39c-.35-3.18-1.93-4.63-5.11-4.63-2.76 0-4.55 1.45-4.55 3.66a3.69 3.69 0 002.13 3.31c.83.56 1.73 1 5.25 2.28 5.25 2 7.73 3.31 9.8 5.18a12.14 12.14 0 013.87 9.25c0 8.55-6.63 14.28-16.5 14.28-10.08 0-16.36-5.73-16.36-14.84z"
					fill="#ffffff"
				/>
				<Path
					d="M153.47 84.5c-5.52 4.69-10.42 6.55-17.26 6.55-7 0-12.63-2.27-16.84-7a25.33 25.33 0 01-6.21-16.84 24.92 24.92 0 018.15-18.84c4.07-3.45 9-5.18 15.25-5.18a27 27 0 0110.9 2.28 22.94 22.94 0 016.54 4.72l-7.18 7.53c-3.24-2.83-6.35-4.14-9.87-4.14-7.38 0-12.49 5.45-12.49 13.32 0 8.14 5.45 13.8 13.18 13.8a11.38 11.38 0 009.18-3.93zM41.59 97.61A5.6 5.6 0 1136.06 92a5.37 5.37 0 015.53 5.61zm-.35 39.47H30.75v-32h10.49zM53.1 105.12v3.59c2.07-3.52 4.28-4.83 8.15-4.83a12 12 0 018.21 3.1c2.14 2.21 2.9 4.83 2.9 10.49v19.61H61.87v-19.54c0-3.1-1.66-5-4.35-5s-4.42 2-4.42 5.11v19.4H42.61v-32zM85.8 137.08H74.61V91h13l12.22 24.78L112 91h13.12v46h-11.23v-26.3l-14 28.16-14.09-28.08z"
					fill="#ffffff"
				/>
				<Path
					d="M138.71 109.47h15.18v9h-15.18V128h15.18v9.05h-26.36V91h26.36v9h-15.18z"
					fill="#ffffff"
				/>
			</Svg>;
}
